module.exports = __webpack_public_path__ + "img/game_tiyu_meishizuqiu.ee23c2f3.png";